export default __webpack_public_path__ + "static/media/Calc.cc4f4022.png";